import React from 'react';

import {EQUIPMENT_SCHEMA_INTERFACE_ID} from 'instruments/equipment/EquipmentConstants';
import {ImplementedStaticSchemaInterface} from 'schemas/SchemaConstants';
import CheckboxInput from 'ui-library/inputs/CheckboxInput';
import {InputChangeEvent} from 'util/Types';

export interface EquipmentInterfaceImplementation extends ImplementedStaticSchemaInterface {
  staticInterfaceFields?: never;
}

export function isEquipmentInterfaceImplementation(
  interfaceImplementation: ImplementedStaticSchemaInterface
): interfaceImplementation is EquipmentInterfaceImplementation {
  return interfaceImplementation.interfaceId === EQUIPMENT_SCHEMA_INTERFACE_ID;
}

function ImplementsEquipmentInterfaceCheckbox(props: {
  checked: boolean;
  disabled: boolean;
  onChange: (e: InputChangeEvent) => void;
  helpText?: string;
}): JSX.Element {
  return (
    <CheckboxInput
      className="u-tiny-spacing-bottom"
      id="configure-equipment-checkbox"
      label="Configure as equipment"
      checked={props.checked}
      onChange={props.onChange}
      disabled={props.disabled}
      helpText={props.helpText}
    />
  );
}

interface ImplementedEquipmentSchemaInterfaceProps {
  isWritable: boolean;
  config: ImplementedStaticSchemaInterface | null;
  isExistingSchema: boolean;
  onUpdate: (implementedEquipmentInterface: ImplementedStaticSchemaInterface | null) => void;
}

export default function ImplementedEquipmentSchemaInterface(
  props: ImplementedEquipmentSchemaInterfaceProps
): JSX.Element {
  const isEquipment = props.config != null;

  function onToggleConfiguration(): void {
    if (props.config == null) {
      props.onUpdate({interfaceId: EQUIPMENT_SCHEMA_INTERFACE_ID});
    } else {
      props.onUpdate(null);
    }
  }

  return (
    <ImplementsEquipmentInterfaceCheckbox
      onChange={onToggleConfiguration}
      checked={isEquipment}
      disabled={!props.isWritable || (props.isExistingSchema && isEquipment)}
      // Keep in sync with back-end
      // `ImplementedEquipmentSchemaInterfaceHandler:HELP_TEXT_FOR_ADDING_INTERFACE_TO_EXISTING_SCHEMA`
      helpText={isEquipment ? 'Cannot uncheck this setting once it is applied to a schema' : undefined}
    />
  );
}
